// apps/admin-ui/src/features/coin-transactions/status-badge.tsx
import type { CoinTxStatus } from '@upme/contracts';
import { Badge } from '@upme/ui/components/badge';

export const STATUS_LABEL: Record<CoinTxStatus, string> = {
  PENDING: 'Ожидает',
  POSTED: 'Зачислено',
  REVERTED: 'Отменено',
};

// PENDING — нейтральный secondary; POSTED — outline + зелёный (как IMPORTED
// в import-queue, у Badge нет success-варианта); REVERTED — destructive.
const STATUS_VARIANT: Record<CoinTxStatus, 'default' | 'secondary' | 'outline' | 'destructive'> = {
  PENDING: 'secondary',
  POSTED: 'outline',
  REVERTED: 'destructive',
};

const STATUS_CLASS: Record<CoinTxStatus, string | undefined> = {
  PENDING: undefined,
  POSTED: 'border-emerald-500 text-emerald-700 dark:text-emerald-400',
  REVERTED: undefined,
};

export function StatusBadge({ status }: { status: CoinTxStatus }) {
  return (
    <Badge variant={STATUS_VARIANT[status]} className={STATUS_CLASS[status]}>
      {STATUS_LABEL[status]}
    </Badge>
  );
}
